import {
    faBug,
    faCheck,
    faPause,
    faSync,
    faUser,
    faClock,
    faTimes,
    faLeftRight,
    faPlus,
    faEllipsisVertical,
    faTriangleExclamation,
    faCircleExclamation,
    faBan,
    faPlusCircle,
    faChevronUp,
    faCircleInfo,
    faChevronDown,
    faHands,
    faLockAlt,
    faLockOpenAlt,
    faMinus,
    faEllipsis,
    faChevronRight,
    faChevronLeft,
    faPenToSquare,
} from '@fortawesome/pro-solid-svg-icons';
import {
    faBanParking,
    faBracketCurly,
    faBuilding,
    faFileCirclePlus,
    faHeadset,
    faNote,
    faTags,
    faArrowUpRightFromSquare,
    faRightFromBracket,
    faPhone,
    faSlidersUp,
    faCode,
    faUsers,
    faEye,
    faCalculator,
    faList,
    faFilter,
    faNewspaper,
    faLinkSlash,
    faEnvelopes,
    IconDefinition,
    faEuro,
    faBox,
    faLandmark,
    faTransporterEmpty,
    faFaceHandPeeking,
    faBadgePercent,
    faUserPlus,
    faFolderPlus,
} from '@fortawesome/pro-duotone-svg-icons';
import { faTrashCan, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { faCircleChevronRight, faPen } from '@fortawesome/sharp-light-svg-icons';
import { NamedIconsType } from '../../types/types';
import { sendIcon } from './userAction';
import { publisherIcon } from './publication';

export const pauseIcon: NamedIconsType = {
    props: { icon: faPause },
    name: 'pause',
    displayName: 'Pause',
};

export const waitIcon: NamedIconsType = {
    props: { icon: faClock },
    name: 'wait',
    displayName: 'En attente',
};

export const checkIcon: NamedIconsType = {
    props: { icon: faCheck },
    name: 'check',
    displayName: 'Coché / Validé',
};

export const manualActionIcon: NamedIconsType = {
    props: { icon: faHands },
    name: 'manualAction',
    displayName: 'Action manuelle',
};

export const newspaperIcon: NamedIconsType = {
    props: { icon: faNewspaper },
    name: 'newspaper',
    displayName: 'Journal',
};

export const errorIcon: NamedIconsType = {
    props: { icon: faTimes },
    name: 'error',
    displayName: 'Erreur / Refusé',
};

export const deleteIcon: NamedIconsType = {
    props: { icon: faTrashCan },
    name: 'delete',
    displayName: 'Supprimer',
};

export const companyIcon: NamedIconsType = {
    props: { icon: faBuilding },
    name: 'company',
    displayName: 'Société',
};

export const tagIcon: NamedIconsType = {
    props: { icon: faTags },
    name: 'tag',
    displayName: 'Tag / Etiquette',
};

export const noteIcon: NamedIconsType = {
    props: { icon: faNote },
    name: 'note',
    displayName: 'Note',
};

export const addNoteIcon: NamedIconsType = {
    props: { icon: faNote, option: faPlus },
    name: 'addNote',
    displayName: 'Ajouter une note',
};

export const dissociateIcon: NamedIconsType = {
    props: { icon: faLinkSlash },
    name: 'dissociate',
    displayName: 'Dissocier',
};

export const exitIcon: NamedIconsType = {
    props: { icon: faCircleChevronRight },
    name: 'exit',
    displayName: 'Retour vers',
};

export const linkIcon: NamedIconsType = {
    props: { icon: faPenToSquare },
    name: 'openInNewTab',
    displayName: 'Ouvrir dans un nouvel onglet',
};

export const editIcon: NamedIconsType = {
    props: { icon: faPen },
    name: 'edit',
    displayName: 'Modifier',
};

export const userIcon: NamedIconsType = {
    props: { icon: faUser },
    name: 'user',
    displayName: 'Utilisateur',
};

export const addFileIcon: NamedIconsType = {
    props: { icon: faFileCirclePlus },
    name: 'addFile',
    displayName: 'Ajout fichier',
};

export const todoIcon: NamedIconsType = {
    props: { icon: faPen },
    name: 'todo',
    displayName: 'À traiter',
};

export const syncIcon: NamedIconsType = {
    props: { icon: faSync },
    name: 'sync',
    displayName: 'Synchronisation',
};

export const unpublishedIcon: NamedIconsType = {
    props: { icon: faBanParking },
    name: 'unpublished',
    displayName: 'Non publié',
};

export const bugIcon: NamedIconsType = {
    props: { icon: faBug },
    name: 'bug',
    displayName: 'Bug',
};

export const supportIcon: NamedIconsType = {
    props: { icon: faHeadset },
    name: 'support',
    displayName: 'Support technique',
};

export const permuteIcon: NamedIconsType = {
    props: { icon: faLeftRight },
    name: 'permute',
    displayName: 'Echange / permutation',
};

export const devIcon: NamedIconsType = {
    props: { icon: faBracketCurly },
    name: 'dev',
    displayName: 'Dev / Version',
};

export const changeCompanyIcon: NamedIconsType = {
    props: {
        icon: companyIcon.props.icon,
        option: permuteIcon.props.icon,
    },
    name: 'changeCompanyIcon',
    displayName: 'Change Company Invoice',
};

export const openIcon: NamedIconsType = {
    props: { icon: faArrowUpRightFromSquare },
    name: 'open',
    displayName: 'Ouvrir',
};

export const plusIcon: NamedIconsType = {
    props: { icon: faPlus },
    name: 'plus',
    displayName: 'Plus / Ajouter',
};

export const minusIcon: NamedIconsType = {
    props: { icon: faMinus },
    name: 'moins',
    displayName: 'Moins / Retirer',
};

export const listIcon: NamedIconsType = {
    props: { icon: faList },
    name: 'list',
    displayName: 'Liste',
};

export const moreIcon: NamedIconsType = {
    props: { icon: faEllipsisVertical },
    name: 'more',
    displayName: 'Afficher plus',
};

export const ellipsisIcon: NamedIconsType = {
    props: { icon: faEllipsis },
    name: 'more',
    displayName: 'Navigation',
};

export const informationIcon: NamedIconsType = {
    props: { icon: faCircleInfo },
    name: 'information',
    displayName: 'Information',
};

export const warningSignIcon: NamedIconsType = {
    props: { icon: faTriangleExclamation },
    name: 'warningSign',
    displayName: 'Attention',
};

export const warningIcon: NamedIconsType = {
    props: { icon: faCircleExclamation },
    name: 'warning',
    displayName: 'Avertissement',
};

export const forbiddenIcon: NamedIconsType = {
    props: { icon: faBan },
    name: 'forbidden',
    displayName: 'Interdit',
};
export const quitIcon: NamedIconsType = {
    props: { icon: faRightFromBracket },
    name: 'exit',
    displayName: 'Quitter',
};

export const mailIcon: NamedIconsType = {
    props: { icon: faEnvelope },
    name: 'mail',
    displayName: 'Mail',
};

export const phoneIcon: NamedIconsType = {
    props: { icon: faPhone },
    name: 'phone',
    displayName: 'Téléphone',
};

export const preferencesIcon: NamedIconsType = {
    props: { icon: faSlidersUp },
    name: 'preferences',
    displayName: 'Préférences',
};
export const codeIcon: NamedIconsType = {
    props: { icon: faCode },
    name: 'code',
    displayName: 'Développement',
};

export const usersIcon: NamedIconsType = {
    props: { icon: faUsers },
    name: 'open',
    displayName: 'Membres / utilisateurs',
};

export const addItem: NamedIconsType = {
    props: { icon: faPlusCircle },
    name: 'addItem',
    displayName: 'Ajouter',
};

export const sendMails: NamedIconsType = {
    props: {
        icon: {
            prefix: 'fad',
            iconName: faEnvelopes.iconName,
        },
        option: {
            prefix: 'fas',
            iconName: (sendIcon.props.icon as IconDefinition).iconName,
        },
    },
    name: 'sendMails',
    displayName: 'Envoyer tous les mails',
};

export const preview: NamedIconsType = {
    props: { icon: faEye },
    name: 'preview',
    displayName: 'Aperçu',
};

export const help: NamedIconsType = {
    props: { icon: faCircleInfo },
    name: 'help',
    displayName: 'Aide',
};

export const chevronUpIcon: NamedIconsType = {
    props: {
        icon: faChevronUp,
    },
    name: 'toggle-up',
    displayName: 'Replier',
};

export const chevronDownIcon: NamedIconsType = {
    props: {
        icon: faChevronDown,
    },
    name: 'toggle-down',
    displayName: 'Déplier',
};

export const chevronLeftIcon: NamedIconsType = {
    props: {
        icon: faChevronLeft,
    },
    name: 'toggle-left',
    displayName: 'Replier',
};

export const chevronRightIcon: NamedIconsType = {
    props: {
        icon: faChevronRight,
    },
    name: 'toggle-right',
    displayName: 'Déplier',
};

export const calculationIcon: NamedIconsType = {
    props: {
        icon: faCalculator,
    },
    name: 'calculation',
    displayName: 'Calculer',
};

export const totalsIcon: NamedIconsType = {
    props: {
        icon: calculationIcon.props.icon,
    },
    name: 'totals',
    displayName: 'Totaux',
};

export const productsIcon: NamedIconsType = {
    props: {
        icon: faList,
    },
    name: 'products',
    displayName: 'Rubriques',
};

export const filtersIcon: NamedIconsType = {
    props: {
        icon: faFilter,
    },
    name: 'filters',
    displayName: 'Filtres',
};

export const lockIcon: NamedIconsType = {
    props: {
        icon: faLockAlt,
    },
    name: 'lock',
    displayName: 'Verrouiller',
};

export const openLockIcon: NamedIconsType = {
    props: {
        icon: faLockOpenAlt,
    },
    name: 'open',
    displayName: 'Ouvrir',
};

export const waitFormalisteIcon: NamedIconsType = {
    props: {
        icon: faCalculator,
        option: userIcon.props.icon,
        color: 'primary.main',
        optionProps: {
            style: {
                translate: '-10% -5%',
            },
        },
        tooltip: 'Prix a définir par nos équipes après étude du dossier',
    },
    name: 'waitFormaliste',
    displayName: 'En attente de retour formaliste',
};
export const emptyIcon: NamedIconsType = {
    props: {
        icon: faTransporterEmpty,
        color: 'primary.main',
        tooltip: 'Aucun élément',
    },
    name: 'EmptyElement',
    displayName: 'Aucun élément',
};
export const hiddenArticleIcon: NamedIconsType = {
    props: {
        icon: faFaceHandPeeking,
        color: 'primary.main',
        tooltip: 'Article masqué',
    },
    name: 'EmptyElement',
    displayName: 'Article masqué',
};
export const AddedArticleIcon: NamedIconsType = {
    props: {
        icon: faPlus,
        color: 'primary.main',
        tooltip: 'Article ajouté',
    },
    name: 'EmptyElement',
    displayName: 'Article ajouté',
};
export const discountIcon: NamedIconsType = {
    props: {
        icon: faBadgePercent,
        color: 'primary.main',
        tooltip: 'Article remise',
    },
    name: 'EmptyElement',
    displayName: 'Article remise',
};

export const euroIcon: NamedIconsType = {
    props: {
        icon: faEuro,
    },
    name: 'euro',
    displayName: 'Euro',
};

export const boxIcon: NamedIconsType = {
    props: {
        icon: faBox,
    },
    name: 'box',
    displayName: 'Box',
};

export const societyIcon: NamedIconsType = {
    props: {
        icon: faLandmark,
    },
    name: 'society',
    displayName: 'Société',
};

export const createPrescriberIcon: NamedIconsType = {
    props: {
        icon: faUserPlus,
        color: 'primary.main',
    },
    name: 'create-prescriber',
    displayName: 'Création de prescripteur',
};

export const createPublisherIcon: NamedIconsType = {
    props: {
        icon: publisherIcon.props.icon,
        option: faPlus,
        color: 'primary.main',
    },
    name: 'create-publisher',
    displayName: 'Création de fournisseur',
};

export const createFormalityFolioIcon: NamedIconsType = {
    props: {
        icon: faFolderPlus,
        color: 'primary.main',
    },
    name: 'create-formality-folio',
    displayName: "Création d'un nouveau dossier de formalité",
};

export const prescribersListIcon: NamedIconsType = {
    props: {
        icon: faList,
        option: usersIcon.props.icon,
    },
    name: 'prescriber',
    displayName: 'Prescripteurs',
};

export const generalNamedIcons: NamedIconsType[] = [
    societyIcon,
    pauseIcon,
    waitIcon,
    checkIcon,
    errorIcon,
    deleteIcon,
    newspaperIcon,
    companyIcon,
    tagIcon,
    noteIcon,
    addNoteIcon,
    exitIcon,
    editIcon,
    userIcon,
    addFileIcon,
    todoIcon,
    syncIcon,
    unpublishedIcon,
    bugIcon,
    supportIcon,
    permuteIcon,
    devIcon,
    changeCompanyIcon,
    openIcon,
    plusIcon,
    minusIcon,
    listIcon,
    moreIcon,
    informationIcon,
    warningIcon,
    forbiddenIcon,
    quitIcon,
    mailIcon,
    phoneIcon,
    preferencesIcon,
    codeIcon,
    usersIcon,
    addItem,
    preview,
    help,
    chevronUpIcon,
    chevronDownIcon,
    totalsIcon,
    manualActionIcon,
    productsIcon,
    filtersIcon,
    euroIcon,
    boxIcon,
    lockIcon,
    openLockIcon,
    waitFormalisteIcon,
    emptyIcon,
];
